const utilizationRx = {
  titleAndSubtitle: {
    title: 'Drug Utilization',
    subtitle:
      'Metrics on drug spend and the drug types with the highest plan impact',
  },
  cardText: {
    planPaidTitle: 'Total Plan Spend',
    planPaidInfo:
      'Total amount paid by the plan for all drug-related claims (Rx + Medpharma).',
    memberPaidTitle: 'Total Member Spend',
    memberPaidInfo:
      'Total out-of-pocket costs incurred by members (copay, coinsurance, deductible) for drug claims.',
    claimsTitle: 'Claim Count',
    claimsInfo:
      'Total number of drug claims submitted across pharmacy and medical channels.',
    brandToGenericRatioTitle: 'Brand-to-Generic Ratio',
    brandToGenericRatioInfo:
      'Ratio of cost spend for brand-name drug claims to generic drug claims.',
    specialityDrugPercentTitle: 'Speciality Drug Spend %',
    specialityDrugPercentInfo:
      'Share of total Rx claims spend attributed to high-cost speciality drugs.',

    members: 'Members',
    totalCost: 'Total Cost',
    medical: 'Medical',
    rx: 'Rx',
    pmpm: 'PMPM',
    pepm: 'PEPM',
  },
  TableText: {
    title: 'In Network',
    subtitle: 'You can switch between In/out networks using the toggle ',
    inNetwork: 'In Network',
    outNetwork: 'Out Network',
  },
  costTrendsChart: {
    chartTitle: 'Pharmacy Cost Trend',
    chartSubTitle:
      'This visual shows the cost trend of medications for the selected period',
  },
  labels: {
    cost: 'Cost',
    months: 'Months',
  },
  medicationByCostTable: {
    title: 'Top Drugs by',
    subtitle: 'These are the Top Medications by Cost',
    leftToggleText: 'In Network',
    rightToggleText: 'Out Network',
  },
  genericDrugsTable: {
    title: 'Top Generic Drugs',
    subtitle: 'These are the Top 5 Generic Drugs by Cost',
  },
  prescriptionDrugs: {
    title: 'Top Brand Drugs',
    subtitle: 'These are the Top 5 Brand Drugs by Cost',
  },
};

export default utilizationRx;
